import moment from 'moment'
import { Typography } from '@mui/material'

interface UserData {
  created_at?: string | number | Date
}

interface ApiUserData {
  iat?: number
}

interface CreatedAtViewProps {
  props: {
    userData?: UserData
    apiUserData?: ApiUserData
  }
}

const CreatedAtView = ({ props }: CreatedAtViewProps) => {
  const userData = props?.userData
  const apiUserData = props?.apiUserData
  const createdAt = userData?.created_at ?? apiUserData?.iat ?? null
  return <Typography sx={{ fontSize: 14 }}>{moment(createdAt).format('DD.MM.YYYY')}</Typography>
}

export default CreatedAtView
